export const E_PROCUREMENTS_RESET_STATE = 'E_PROCUREMENTS_RESET_STATE';
export const E_PROCUREMENTS_CURRENT_ITEM = 'E_PROCUREMENTS_CURRENT_ITEM';

export const E_PROCUREMENTS_REQUEST_LOADING = 'E_PROCUREMENTS_REQUEST_LOADING';
export const E_PROCUREMENTS_REQUEST_SUCCESS = 'E_PROCUREMENTS_REQUEST_SUCCESS';
export const E_PROCUREMENTS_REQUEST_FAILED = 'E_PROCUREMENTS_REQUEST_FAILED';

export const E_PROCUREMENTS_CURRENT_ACTION = 'E_PROCUREMENTS_CURRENT_ACTION';
export const E_PROCUREMENTS_RESET_ACTION = 'E_PROCUREMENTS_RESET_ACTION';